export * from './generic-api.type';
